import {AddressField} from './address-field';
import {CompanyNameField} from './company-name-field';
import {DepartmentField} from './department-field';
import {EmailCcField} from './email-cc-field';
import {EmailField} from './email-field';
import {NameField} from './name-field';
import {NameKanaField} from './name-kana-field';

export const billingInfoFields = {
  addressField: AddressField,
  companyNameField: CompanyNameField,
  departmentField: DepartmentField,
  emailCcField: EmailCcField,
  emailField: EmailField,
  nameField: NameField,
  nameKanaField: NameKanaField,
};
